import { z } from "zod";

const schema = z.object({
	longitude: z.number().nullable(), // 경도 x좌표
	latitude: z.number().nullable() // 위도 y좌표
});

const model = schema.transform((values) => ({
	...values
}));

export const CoordinateModel = { schema, model };
export type ICoordinateModel = z.infer<typeof CoordinateModel.model>;
export const DEFAULT_COORDINATE: ICoordinateModel = {
	longitude: -1,
	latitude: -1
};
